"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1925],{

/***/ 98999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useCartProductMeta; },
/* harmony export */   "x": function() { return /* binding */ useProductCartWarnings; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85034);
/* harmony import */ var utils_buildProductUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69377);


var getMetaForProduct = function(productCartItem, giftCardName, compact) {
    if (productCartItem.__typename === "ProductCartItem") {
        var product = productCartItem.product;
        var outOfStock = productCartItem.hasStock !== undefined && productCartItem.hasStock !== null ? !productCartItem.hasStock : (product.inventory || 0) < productCartItem.quantity;
        var adjustQuantityMessage = productCartItem.adjustQuantityMessage || undefined;
        var pdpUrl = (0,utils_buildProductUrl__WEBPACK_IMPORTED_MODULE_0__/* .buildProductUrl */ .B)(product.masterId, product.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            color: product.colorValue
        }, product.size.value && {
            size: product.size.value
        }));
        var imageUrl = !compact && productCartItem.personalizationImageURL ? productCartItem.personalizationImageURL : product.images[0].href;
        var _stockMessageCode;
        var stockMessageCode = (_stockMessageCode = productCartItem.stockMessageCode) !== null && _stockMessageCode !== void 0 ? _stockMessageCode : undefined;
        return {
            adjustQuantityMessage: adjustQuantityMessage,
            stockMessageCode: stockMessageCode,
            name: product.name,
            pdpUrl: pdpUrl,
            outOfStock: outOfStock,
            imageUrl: imageUrl
        };
    }
    return {
        adjustQuantityMessage: undefined,
        name: giftCardName,
        pdpUrl: "/pd/digital-gift-card/VirtualGiftCard",
        outOfStock: false,
        imageUrl: productCartItem.imageUrl,
        stockMessageCode: undefined
    };
};
var useProductCartWarnings = function(cart) {
    return (cart === null || cart === void 0 ? void 0 : cart.products) ? cart === null || cart === void 0 ? void 0 : cart.products.map(function(product) {
        var _meta = getMetaForProduct(product, "");
        if (_meta.outOfStock || _meta.adjustQuantityMessage && _meta.stockMessageCode) {
            return _meta.adjustQuantityMessage;
        }
        return null;
    }).filter(function(item) {
        return item != null;
    }) : [];
};
var useCartProductMeta = function() {
    return {
        getMetaForProduct: getMetaForProduct
    };
};


/***/ }),

/***/ 5606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useCheckoutPayment; },
/* harmony export */   "Q": function() { return /* binding */ CheckoutPaymentProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20368);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79758);







var CheckoutPaymentContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);
var CheckoutPaymentProvider = function(props) {
    var defaultPaymentMethod = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__/* .useSiteConfig */ .N)().defaultPaymentMethod;
    var ref;
    // --------------------------------------------------------------------
    // Hoisted form states
    // --------------------------------------------------------------------
    //
    // These are states hoisted up, so it can be shared with the <FormButton />.
    // Every payment type has the option to manipulate these as they seem fit.
    //
    // TODO: Think about bringing this inside the <FormBody />. That would allow
    // us to remove the hoisting and the simplify the context.
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        formDisabled: false,
        formLoading: false,
        submitButtonEnabled: true,
        currentPaymentMethod: (ref = defaultPaymentMethod) !== null && ref !== void 0 ? ref : utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PaymentMethod.CREDIT_CARD */ .XL.CREDIT_CARD,
        allowedPaymentMethods: [],
        formError: undefined
    }), 2), formState = ref1[0], setFormState = ref1[1];
    var formHandler = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var setCurrentPaymentMethod = function(currentPaymentMethod) {
        var submitButtonEnabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setFormState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, prevState), {
                formError: undefined,
                currentPaymentMethod: currentPaymentMethod,
                submitButtonEnabled: submitButtonEnabled
            });
        });
    };
    var setAllowedPaymentMethods = function(allowedPaymentMethods) {
        setFormState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, prevState), {
                formError: undefined,
                allowedPaymentMethods: allowedPaymentMethods
            });
        });
    };
    var setFormLoading = function(loading) {
        setFormState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, prevState), {
                formDisabled: loading,
                formLoading: loading,
                formError: loading ? undefined : prevState.formError
            });
        });
    };
    var setFormDisabled = function(disabled) {
        setFormState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, prevState), {
                formDisabled: disabled
            });
        });
    };
    var setSubmitButtonEnabled = function(enabled) {
        setFormState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, prevState), {
                submitButtonEnabled: enabled
            });
        });
    };
    var setFormError = function(formError) {
        setFormState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, prevState), {
                formError: formError
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CheckoutPaymentContext.Provider, {
        value: react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
            return {
                formHandler: formHandler,
                formState: formState,
                setFormLoading: setFormLoading,
                setFormDisabled: setFormDisabled,
                setSubmitButtonEnabled: setSubmitButtonEnabled,
                setFormError: setFormError,
                setCurrentPaymentMethod: setCurrentPaymentMethod,
                setAllowedPaymentMethods: setAllowedPaymentMethods
            };
        }, [
            formState
        ]),
        children: props.children
    });
};
var useCheckoutPayment = function() {
    return react__WEBPACK_IMPORTED_MODULE_1__.useContext(CheckoutPaymentContext);
};


/***/ }),

/***/ 67604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useDateFormatter; }
/* harmony export */ });
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20368);
/* harmony import */ var _useTranslations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77480);


var weekDayNames = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday", 
];
var useDateFormatter = function(param) {
    var date = param.date, format = param.format, _text = param.text, text = _text === void 0 ? "emptyTranslation" : _text;
    var t = (0,_useTranslations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .qM)();
    var localizeDate = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_0__/* .useSiteConfig */ .N)().localizeDate;
    if (!format) return localizeDate(date);
    var givenDate = new Date(date);
    var year = givenDate.getFullYear();
    var month = givenDate.getMonth() + 1;
    var day = givenDate.getDate();
    var weekDay = givenDate.getDay();
    var replacedParts = {
        YYYY: String(year),
        TY: t("year"),
        MM: String(month).padStart(2, "0"),
        TM: t("month"),
        DD: String(day).padStart(2, "0"),
        TD: t("day"),
        TW: t(weekDayNames[weekDay]),
        TEXT: t(text)
    };
    var _part;
    return format.reduce(function(result, part) {
        return result += (_part = replacedParts[part]) !== null && _part !== void 0 ? _part : part;
    }, "");
};


/***/ }),

/***/ 24742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useOrderDiscountValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var utils_isNotNullish__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50597);


var useOrderDiscountValue = function(subTotal, products) {
    var calculateDiscountValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!products) return 0;
        var fullPrice = products.reduce(function(acc, cur) {
            if (cur.__typename === "ProductCartItem") {
                // `personalizationPrice` can be higher than the catalogue price
                var productCartItemFullPrice = (0,utils_isNotNullish__WEBPACK_IMPORTED_MODULE_1__/* .isNotNullish */ .l)(cur.personalizationPrice) ? parseFloat(cur.personalizationPrice) : cur.product.price;
                return acc + cur.quantity * productCartItemFullPrice;
            }
            if (cur.__typename === "GiftCardCartItem") {
                return acc + cur.amount;
            }
            return acc;
        }, 0);
        return fullPrice - (subTotal || 0);
    }, [
        subTotal,
        products
    ]);
    return calculateDiscountValue;
};


/***/ }),

/***/ 34617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ AvailabilityBadge; },
/* harmony export */   "v": function() { return /* binding */ STOCK_MESSAGE_CODE; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53625);





var STOCK_MESSAGE_CODE;
(function(STOCK_MESSAGE_CODE) {
    STOCK_MESSAGE_CODE["IN_STOCK"] = "IN_STOCK";
    STOCK_MESSAGE_CODE["LIMITED_STOCK"] = "LIMITED_STOCK";
    STOCK_MESSAGE_CODE["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(STOCK_MESSAGE_CODE || (STOCK_MESSAGE_CODE = {}));
var AvailabilityBadge = function(param) {
    var className = param.className, outOfStock = param.outOfStock, offline = param.offline, stockMessage = param.stockMessage, stockStatus = param.stockStatus;
    var shouldUseStockMessageFromResponse = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__/* .useFeature */ .S)("USE_STOCK_MESSAGE_FROM_RESPONSE");
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var isOutOfStock = outOfStock || shouldUseStockMessageFromResponse && stockStatus === "NOT_AVAILABLE";
    var isLimitedStock = shouldUseStockMessageFromResponse && stockStatus === "LIMITED_STOCK";
    var hasStockMessage = shouldUseStockMessageFromResponse && stockMessage ? true : false;
    var getBadgeLabel = function() {
        switch(true){
            case hasStockMessage:
                return stockMessage;
            case isOutOfStock:
                return t("outOfStock");
            case offline:
                return t("noLongerAvailable");
            case isLimitedStock:
                return t("inStock");
            default:
                return t("inStock");
        }
    };
    var getBadgeColor = function() {
        switch(true){
            case isOutOfStock:
                return "brand";
            case offline:
                return "muted";
            case isLimitedStock:
                return "warning";
            default:
                return "success";
        }
    };
    var getBadgeIcon = function() {
        switch(true){
            case isOutOfStock:
                return "close-filled";
            case offline:
                return "close-filled";
            case isLimitedStock:
                return "exclamation-filled";
            default:
                return "check-filled";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Badge */ .Cts, {
        className: className,
        "data-test-id": "stock-availability",
        outline: true,
        round: true,
        size: "sm",
        icon: getBadgeIcon(),
        color: getBadgeColor(),
        label: getBadgeLabel()
    });
};


/***/ }),

/***/ 57965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ConfirmModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70868);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51377);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6485);







var ConfirmModal = function(param) {
    var onClickOutside = param.onClickOutside, children = param.children, onConfirm = param.onConfirm, dataTestId = param.dataTestId, loading = param.loading, confirmText = param.confirmText, cancelText = param.cancelText, reverseButtonOrder = param.reverseButtonOrder;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var confirmButton = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
            id: "confirm-button",
            dataTestId: "confirm-button",
            loading: loading,
            label: confirmText !== null && confirmText !== void 0 ? confirmText : t("confirmButtonModal"),
            className: "flex-grow h-[2.5rem]",
            onClick: onConfirm,
            children: confirmText !== null && confirmText !== void 0 ? confirmText : t("confirmButtonModal")
        });
    };
    var cancelButton = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
            id: "cancel-button",
            dataTestId: "cancel-button",
            label: cancelText !== null && cancelText !== void 0 ? cancelText : t("cancelButtonModal"),
            variant: reverseButtonOrder ? "secondary" : "primary",
            className: "flex-grow",
            onClick: onClickOutside
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onClickOutside: onClickOutside,
        variant: "dark",
        className: "max-w-lg p-6",
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "absolute top-5 right-5 !mt-0",
                onClick: onClickOutside
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-6",
                children: [
                    children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex space-x-4 w-full",
                        children: reverseButtonOrder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                cancelButton(),
                                confirmButton()
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                confirmButton(),
                                cancelButton()
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 6723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ EditProductModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70868);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77480);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51377);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37678);
/* harmony import */ var utils_extractError__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4360);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53625);
/* harmony import */ var utils_products__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1032);
/* harmony import */ var _Sizes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38913);
/* harmony import */ var _Styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87260);
/* harmony import */ var _Price__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81406);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6485);

















var EditProductModal = function(props) {
    var ref, ref1;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .qM)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.color), selectedColor = ref2[0], setSelectedColor = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.size), selectedSize = ref3[0], setSelectedSize = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSameProduct = ref4[0], setIsSameProduct = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), updating = ref5[0], setUpdating = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), error = ref6[0], setError = ref6[1];
    var showPriceDifference = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_7__/* .useFeature */ .S)("SHOW_PRICE_DIFFERENCE");
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useProductQuery */ .FA3)({
        variables: {
            id: props.masterId
        },
        pause: !props.masterId
    }), 1), product = ref7[0];
    var masterProduct = (ref = product.data) === null || ref === void 0 ? void 0 : ref.product;
    var chosenVariant = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.find(function(x) {
        return x.colorValue === selectedColor;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!chosenVariant) return;
        setIsSameProduct(chosenVariant.colorValue === props.color);
    }, [
        chosenVariant,
        props.color
    ]);
    if (!chosenVariant || !masterProduct) {
        return null;
    }
    var sizes = (0,utils_products__WEBPACK_IMPORTED_MODULE_8__/* .getSizesFromSizeGroups */ .hJ)(chosenVariant.sizeGroups);
    var selectedSizeIsOrderable = (ref1 = sizes.find(function(x) {
        return x.id === selectedSize;
    })) === null || ref1 === void 0 ? void 0 : ref1.orderable;
    var priceDifference = (chosenVariant.salePrice || chosenVariant.price) - props.price;
    var productVariations = (masterProduct.variations || []).filter(function(x) {
        var ref;
        return !((ref = x.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.comingsoon);
    });
    var styleNumberPrefix = t("styleNumberModalCart");
    var colorPrefix = t("colorModalCart");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onClickOutside: props.onClose,
        variant: "dark",
        className: "w-full max-w-md p-8 sm:p-10 m-auto",
        dataTestId: "edit-product-modal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                className: "absolute top-5 right-5 !mt-0",
                onClick: props.onClose
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-4 sm:space-y-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            styleNumberPrefix ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-puma-black-300",
                                        children: styleNumberPrefix
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "text-puma-black",
                                        children: [
                                            props.masterId,
                                            "_",
                                            selectedColor
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "text-puma-black-300",
                                children: [
                                    "#",
                                    props.masterId,
                                    "_",
                                    selectedColor
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-xl md:text-3xl font-bold leading-tight",
                                children: masterProduct.name
                            }),
                            colorPrefix ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-puma-black-300",
                                        children: colorPrefix
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-puma-black",
                                        children: chosenVariant.colorName
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-puma-black",
                                children: chosenVariant.colorName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Styles__WEBPACK_IMPORTED_MODULE_10__/* .Styles */ .z, {
                        desiredSwatch: selectedColor,
                        variations: productVariations,
                        onChange: function(swatch) {
                            setUpdating(false);
                            setError(undefined);
                            setSelectedColor(swatch);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Sizes__WEBPACK_IMPORTED_MODULE_9__/* .Sizes */ .u8, {
                        sizeGroups: chosenVariant.sizeGroups,
                        desiredSize: selectedSize,
                        onChange: function(newSize) {
                            setUpdating(false);
                            setError(undefined);
                            setSelectedSize(newSize);
                        }
                    }),
                    error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex items-center space-x-3 justify-between text-puma-red border border-puma-red font-bold px-3 py-2 text-sm rounded mb-2 -mt-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: error
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                name: "exclamation-outline",
                                size: "base"
                            })
                        ]
                    }),
                    !selectedSizeIsOrderable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex items-center space-x-3 justify-between text-puma-red border border-puma-red font-bold px-3 py-2 text-sm rounded mb-2 -mt-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("selectedSizeIsNotOrderable")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                name: "exclamation-outline",
                                size: "base"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        label: t("updateItem"),
                        id: "save-product",
                        height: "tall",
                        className: "w-full",
                        loading: updating,
                        disabled: updating || !selectedSizeIsOrderable,
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
                            var result, _tmp;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setUpdating(true);
                                        _tmp = {};
                                        return [
                                            4,
                                            props.update((_tmp.size = selectedSize, _tmp.swatch = selectedColor, _tmp))
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        if (result.error) {
                                            setError((0,utils_extractError__WEBPACK_IMPORTED_MODULE_16__/* .extractError */ .d)(result));
                                            setUpdating(false);
                                        } else {
                                            props.onClose();
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: [
                            t("updateItem"),
                            showPriceDifference && !isSameProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceDifference, {
                                difference: priceDifference
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var PriceDifference = function(props) {
    if (!props.difference) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            " (",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_11__/* .Price */ .t, {
                amount: props.difference,
                showSign: true
            }),
            ")"
        ]
    });
};


/***/ }),

/***/ 50042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ GWPFreeGiftMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66224);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53625);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);






var GWPFreeGiftMessage = function(param) {
    var gwpTitle = param.gwpTitle;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var isGiftWithPurchaseNewDesign = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__/* .useFeature */ .S)("GIFT_WITH_PURCHASE_NEW_DESIGN");
    if (isGiftWithPurchaseNewDesign && gwpTitle) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "alert",
        className: "flex items-center space-x-2 text-xs text-success-60",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
                name: "gift",
                size: "2xl"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "font-bold uppercase text-sm mb-0.5",
                children: gwpTitle
            })
        ]
    });
    if (!isGiftWithPurchaseNewDesign) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__/* .AlertMessage */ .g, {
        type: "success",
        icon: "gift",
        dataTestId: "free-gift-message",
        children: t("freeGiftWithPurchaseItem")
    });
    return null;
};


/***/ }),

/***/ 10796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ PriceBreakdown; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useOrderDiscountValue.ts
var useOrderDiscountValue = __webpack_require__(24742);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./utils/isNumber.ts
var isNumber = __webpack_require__(95442);
// EXTERNAL MODULE: ./hooks/a11y/index.ts + 4 modules
var a11y = __webpack_require__(71129);
// EXTERNAL MODULE: ./hooks/useCheckoutPayment.tsx
var useCheckoutPayment = __webpack_require__(5606);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./utils/parseTaxTotal.ts

var parseTaxTotal = function(taxTotal) {
    return (0,isNumber/* isNumber */.h)(taxTotal) ? taxTotal : 0;
};

// EXTERNAL MODULE: ./ui/components/Price.tsx
var Price = __webpack_require__(81406);
;// CONCATENATED MODULE: ./ui/components/PriceBreakdown.tsx
















var KlarnaText = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7621).then(__webpack_require__.bind(__webpack_require__, 27621));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27621)
            ];
        }
    },
    ssr: false
});
var InfoBubble = function(props) {
    var infoRef = react.useRef(null);
    (0,a11y/* useDialogDismiss */.sH)({
        ref: infoRef,
        handler: props.onClickOutside || function() {
            return null;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: infoRef,
        className: "w-60 p-3 border-2 right-1/4 translate-x-1/4 group absolute bottom-7 bg-white rounded cursor-default text-left",
        children: [
            props.text,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-3 h-3 -bottom-[14px] border-b-2 border-r-2 rounded-[-20px] transform right-1/4 translate-x-1/3 -translate-y-1/2 bg-white rotate-45"
            })
        ]
    });
};
var Total = function(param) {
    var total = param.total;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: total ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
            amount: total
        }) : "-"
    });
};
var TotalMinusTaxes = function(param) {
    var estimatedTotal = param.estimatedTotal, taxTotal = param.taxTotal;
    var showSubtotal = (0,isNumber/* isNumber */.h)(estimatedTotal);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showSubtotal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
            amount: estimatedTotal - parseTaxTotal(taxTotal)
        }) : "-"
    });
};
var PriceBreakdown = function(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var entity = props.order || props.cart;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "price-breakdown-title",
                className: "sr-only",
                children: t("priceBreakdown")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "font-bold text-sm text-puma-black-300 uppercase",
                "data-test-id": "order-summary",
                "aria-labelledby": "price-breakdown-title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteWideDiscounts, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YourSavings, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtotal, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingCosts, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingSurcharge, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDiscounts, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CashOnDeliveryFee, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizationAdjustment, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingAdjustments, {
                        entity: entity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxTotal, {
                        entity: entity,
                        isEstimate: props.isEstimate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalDetails, {
                        entity: entity,
                        isEstimate: props.isEstimate
                    })
                ]
            }),
            !props.isConfirmationPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KlarnaText, {
                    amount: entity === null || entity === void 0 ? void 0 : entity.estimatedTotal
                })
            })
        ]
    });
};
var SiteWideDiscounts = function(props) {
    var ref;
    var showDiscountAmountAndTextEnabled = (0,useFeature/* useFeature */.S)("SHOW_DISCOUNT_AMOUNT_AND_TEXT_ENABLED");
    if (!showDiscountAmountAndTextEnabled) return null;
    var ref1;
    var siteWideDiscounts = ((ref1 = (ref = props.entity) === null || ref === void 0 ? void 0 : ref.orderAdjustments) !== null && ref1 !== void 0 ? ref1 : []).filter(function(item) {
        return !item.couponCode;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: siteWideDiscounts.map(function(param, index) {
            var promotionId = param.promotionId, itemText = param.itemText, price = param.price;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                "data-test-id": "order-discount-line-item",
                className: (0,twind.tw)("text-puma-black", index === siteWideDiscounts.length - 1 && "mb-10"),
                children: promotionId && itemText && (0,isNumber/* isNumber */.h)(price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "flex justify-between whitespace-nowrap font-normal",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "whitespace-normal mr-10",
                            children: itemText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-puma-green",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                amount: price
                            })
                        })
                    ]
                })
            }, promotionId);
        })
    });
};
var YourSavings = function(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var staticFeatures = (0,useSiteConfig/* useSiteConfig */.N)().staticFeatures;
    var hideYourSavings = (0,useFeature/* useFeature */.S)("HIDE_YOUR_SAVINGS");
    var showDiscountAmountAndTextEnabled = (0,useFeature/* useFeature */.S)("SHOW_DISCOUNT_AMOUNT_AND_TEXT_ENABLED");
    var _entity;
    var ref = (_entity = props.entity) !== null && _entity !== void 0 ? _entity : {}, subTotal = ref.subTotal, products = ref.products;
    var profit = (0,useOrderDiscountValue/* useOrderDiscountValue */.A)(subTotal, products);
    if (hideYourSavings || showDiscountAmountAndTextEnabled || !profit) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between ".concat(staticFeatures.isPNARegion ? "text-puma-green" : "text-puma-gold", " mt-1"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: t("yourSavings")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "savings",
                "data-breakdown-row": "savings",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: profit * -1
                })
            })
        ]
    });
};
var Subtotal = function(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var _entity;
    var subTotal = ((_entity = props.entity) !== null && _entity !== void 0 ? _entity : {}).subTotal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between mt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: t("subtotal")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "subtotal",
                "data-breakdown-row": "subtotal",
                children: subTotal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: subTotal
                }) : "-"
            })
        ]
    });
};
var ShippingCosts = function(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var _entity;
    var ref = (_entity = props.entity) !== null && _entity !== void 0 ? _entity : {}, estimatedShippingCosts = ref.estimatedShippingCosts, shippingCosts = ref.shippingCosts;
    var checkoutPayment = (0,useCheckoutPayment/* useCheckoutPayment */.H)();
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), country = ref1.country, showFreeShippingCost = ref1.staticFeatures.showFreeShippingCost;
    var ref2, ref3;
    // We should default to displaying estimatedShippingCosts only
    // if the country is not IN and the payment method is not COD.
    // Otherwise, display shippingCost.
    var total = country === constants/* SUPPORTED_COUNTRY.IN */.bM.IN && (checkoutPayment === null || checkoutPayment === void 0 ? void 0 : checkoutPayment.formState.currentPaymentMethod) === constants/* PaymentMethod.COD */.XL.COD ? (ref2 = shippingCosts !== null && shippingCosts !== void 0 ? shippingCosts : estimatedShippingCosts) !== null && ref2 !== void 0 ? ref2 : 0 : (ref3 = estimatedShippingCosts !== null && estimatedShippingCosts !== void 0 ? estimatedShippingCosts : shippingCosts) !== null && ref3 !== void 0 ? ref3 : 0;
    var freeShipping = total === 0 && showFreeShippingCost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between mt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: t("shippingCosts")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "shipping",
                "data-breakdown-row": "shipping",
                children: freeShipping ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("free")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: total
                })
            })
        ]
    });
};
var ShippingSurcharge = function(props) {
    var _entity;
    var shippingSurcharge = ((_entity = props.entity) !== null && _entity !== void 0 ? _entity : {}).shippingSurcharge;
    if (!shippingSurcharge) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between mt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center space-x-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: shippingSurcharge.label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "shipping-surcharge",
                "data-breakdown-row": "shipping-surcharge",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: shippingSurcharge.amount
                })
            })
        ]
    });
};
var OrderDiscounts = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1;
    var orderAdjustments = (ref1 = (ref = props.entity) === null || ref === void 0 ? void 0 : ref.orderAdjustments) !== null && ref1 !== void 0 ? ref1 : [];
    var orderDiscountsWithoutCodFee = orderAdjustments.filter(function(adj) {
        return adj.promotionId !== "codFee";
    });
    if (!orderDiscountsWithoutCodFee.length) return null;
    var totalOrderDiscount = orderDiscountsWithoutCodFee.reduce(function(sum, item) {
        var _price;
        return sum + ((_price = item.price) !== null && _price !== void 0 ? _price : 0);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between mt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "uppercase",
                children: t("orderDiscount")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "order-discount",
                "data-breakdown-row": "order-discount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: totalOrderDiscount
                })
            })
        ]
    });
};
var CashOnDeliveryFee = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1;
    var codFee = ((ref1 = (ref = props.entity) === null || ref === void 0 ? void 0 : ref.orderAdjustments) !== null && ref1 !== void 0 ? ref1 : []).find(function(adj) {
        return adj.promotionId === "codFee";
    });
    if (!codFee || !(0,isNumber/* isNumber */.h)(codFee === null || codFee === void 0 ? void 0 : codFee.price)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between mt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "uppercase",
                children: t("codFee")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "codfee-discount",
                "data-breakdown-row": "codfee-discount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: codFee.price
                })
            })
        ]
    });
};
var CustomizationAdjustment = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1;
    var price = ((ref1 = (ref = props.entity) === null || ref === void 0 ? void 0 : ref.customizationAdjustment) !== null && ref1 !== void 0 ? ref1 : {}).price;
    if (!(0,isNumber/* isNumber */.h)(price)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between mt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "uppercase",
                children: t("customizationCost")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "customization-cost",
                "data-breakdown-row": "order-discount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: price
                })
            })
        ]
    });
};
var ShippingAdjustments = function(props) {
    var checkoutPayment = (0,useCheckoutPayment/* useCheckoutPayment */.H)();
    var t = (0,useTranslations/* useTranslate */.qM)();
    var _entity;
    var shippingAdjustments = ((_entity = props.entity) !== null && _entity !== void 0 ? _entity : {}).shippingAdjustments;
    var COD_SHIPPING_FEE = "COD Shipping Fee";
    // Hide Shipping Discount if COD Shipping Fee applies
    if (!(shippingAdjustments === null || shippingAdjustments === void 0 ? void 0 : shippingAdjustments.length) || (checkoutPayment === null || checkoutPayment === void 0 ? void 0 : checkoutPayment.formState.currentPaymentMethod) === constants/* PaymentMethod.COD */.XL.COD && (shippingAdjustments === null || shippingAdjustments === void 0 ? void 0 : shippingAdjustments.some(function(item) {
        return item.promotionId === COD_SHIPPING_FEE;
    }))) return null;
    var total = shippingAdjustments.reduce(function(sum, item) {
        var promotionId = item.promotionId, price = item.price;
        return sum + (promotionId === COD_SHIPPING_FEE ? 0 : price !== null && price !== void 0 ? price : 0);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between mt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "uppercase",
                children: t("shippingDiscount")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "shipping-discount",
                "data-breakdown-row": "shipping-discount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: total
                })
            })
        ]
    });
};
var TaxTotal = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var _entity;
    var ref1 = (_entity = props.entity) !== null && _entity !== void 0 ? _entity : {}, taxation = ref1.taxation, taxTotal = ref1.taxTotal, shipment = ref1.shipment;
    var isCartPage = router.pathname.includes("/cart");
    var showTaxTotal = shouldTaxTotalRender({
        taxTotal: taxTotal,
        isCartPage: isCartPage,
        postalCode: shipment === null || shipment === void 0 ? void 0 : (ref = shipment.address) === null || ref === void 0 ? void 0 : ref.postalCode
    });
    var ref2 = (0,react.useState)(false), showSalesTaxInfo = ref2[0], setShowSalesTaxInfo = ref2[1];
    if (taxation === "gross") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between mt-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: t(props.isEstimate ? "estimatedSalesTax" : "salesTax")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "ml-2 relative",
                        type: "button",
                        onClick: function() {
                            return setShowSalesTaxInfo(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: t("learnTax")
                            }),
                            isCartPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                name: "info",
                                size: "xl"
                            }),
                            showSalesTaxInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBubble, {
                                onClickOutside: function() {
                                    return setShowSalesTaxInfo(false);
                                },
                                text: t("calculatedTaxToolTip")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-right whitespace-nowrap",
                "data-test-id": "sales-tax",
                "data-breakdown-row": "sales-tax",
                children: showTaxTotal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                    amount: taxTotal
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "_"
                })
            })
        ]
    });
};
var TotalDetails = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var _entity;
    var ref1 = (_entity = props.entity) !== null && _entity !== void 0 ? _entity : {}, taxation = ref1.taxation, taxTotal = ref1.taxTotal, shipment = ref1.shipment, estimatedTotal = ref1.estimatedTotal;
    var isCartPage = router.pathname.includes("/cart");
    var showTaxTotal = shouldTaxTotalRender({
        taxation: taxation,
        taxTotal: taxTotal,
        isCartPage: isCartPage,
        postalCode: shipment === null || shipment === void 0 ? void 0 : (ref = shipment.address) === null || ref === void 0 ? void 0 : ref.postalCode
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex justify-between pt-6 border-t border-puma-black-500 mt-6 font-bold text-xl text-puma-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap items-baseline",
                "data-test-id": props.isEstimate ? "estimated-total-title" : "total-title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                    className: "mr-2.5",
                    children: [
                        t(props.isEstimate ? "estimatedTotal" : "total"),
                        t("priceClarification") && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block text-sm text-puma-black-300 xs:inline xs:pl-2",
                            children: t("priceClarification")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "whitespace-nowrap",
                "data-test-id": "estimated-total",
                children: showTaxTotal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                    total: estimatedTotal
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalMinusTaxes, {
                    estimatedTotal: estimatedTotal,
                    taxTotal: taxTotal
                })
            })
        ]
    });
};
var shouldTaxTotalRender = function(args) {
    if (args.taxation === "gross") return true; // Always show if taxation is gross
    if (!(0,isNumber/* isNumber */.h)(args.taxTotal)) return false; // Don't show if we don't have a valid tax total
    if (args.isCartPage) return false; // Don't show on cart page
    if (!args.postalCode) return false; // Don't show if we don't have a postal code
    return true;
};


/***/ }),

/***/ 44851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ RestrictedProductMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77480);
/* harmony import */ var ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66224);




var RestrictedProductMessage = function(param) {
    var _plural = param.plural, plural = _plural === void 0 ? false : _plural, dataTestId = param.dataTestId;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var message = plural ? t("productsCannotBeShippedToYourState") : t("productCannotBeShippedToYourState");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__/* .AlertMessage */ .g, {
        type: "warning",
        icon: "exclamation-outline",
        dataTestId: dataTestId,
        children: message
    });
};


/***/ }),

/***/ 73022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20368);
/* harmony import */ var hooks_useDateFormatter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67604);





var ScheduledArrivalDate = function(param) {
    var preOrderDeliveryDate = param.preOrderDeliveryDate;
    var scheduledArrivalDateFormat = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__/* .useSiteConfig */ .N)().scheduledArrivalDateFormat;
    var dateFormatOptions = {
        date: preOrderDeliveryDate,
        format: scheduledArrivalDateFormat,
        text: "scheduledArrivalDate"
    };
    var formattedDate = (0,hooks_useDateFormatter__WEBPACK_IMPORTED_MODULE_4__/* .useDateFormatter */ .a)(dateFormatOptions);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .LiveRegion */ .LE2, {
        type: "polite",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Alert */ .bZj, {
            content: formattedDate,
            variant: "info"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScheduledArrivalDate);


/***/ }),

/***/ 65733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ ProductInfoRow; },
  "y": function() { return /* binding */ ShoppingCartItem; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./ui/components/EditProductModal.tsx
var EditProductModal = __webpack_require__(6723);
// EXTERNAL MODULE: ./ui/components/ConfirmModal.tsx
var ConfirmModal = __webpack_require__(57965);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useResizeObserver.ts
var useResizeObserver = __webpack_require__(13765);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/extractError.ts
var extractError = __webpack_require__(4360);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/useCartProductMeta.ts
var useCartProductMeta = __webpack_require__(98999);
// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./sites/types.ts
var types = __webpack_require__(81526);
// EXTERNAL MODULE: ./utils/ga4Items.ts
var ga4Items = __webpack_require__(54093);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./utils/isNotNullish.ts
var isNotNullish = __webpack_require__(50597);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./ui/elements/AlertMessage.tsx
var AlertMessage = __webpack_require__(66224);
// EXTERNAL MODULE: ./utils/countingNumbers.ts
var countingNumbers = __webpack_require__(46857);
// EXTERNAL MODULE: ./ui/components/AvailabilityBadge.tsx
var AvailabilityBadge = __webpack_require__(34617);
// EXTERNAL MODULE: ./ui/components/Img.tsx
var Img = __webpack_require__(53579);
// EXTERNAL MODULE: ./ui/components/Price.tsx
var Price = __webpack_require__(81406);
// EXTERNAL MODULE: ./ui/components/ProductPrice/ProductPrice.tsx + 3 modules
var ProductPrice = __webpack_require__(1108);
// EXTERNAL MODULE: ./ui/components/RestrictedProductMessage.tsx
var RestrictedProductMessage = __webpack_require__(44851);
// EXTERNAL MODULE: ./ui/components/GiftWithPurchase/GWP.FreeGiftMessage.tsx
var GWP_FreeGiftMessage = __webpack_require__(50042);
;// CONCATENATED MODULE: ./ui/components/ShoppingCartItem/primary.tsx
















var ShoppingCartItemPrimaryNested = function(param) {
    var item = param.item, compact = param.compact, preventItemLinks = param.preventItemLinks, isOffline = param.isOffline, meta = param.meta, updating = param.updating, removing = param.removing, maxPurchasableQuantity = param.maxPurchasableQuantity, showAlertMessage = param.showAlertMessage, allowUpdate = param.allowUpdate, allowRemove = param.allowRemove, onChangeQuantity = param.onChangeQuantity, basketId = param.basketId, totalProductPrice = param.totalProductPrice, salePrice = param.salePrice, promotionMessages = param.promotionMessages, promotionPrice = param.promotionPrice, onEdit = param.onEdit, onRemove = param.onRemove, error = param.error, isPurchased = param.isPurchased, personalizationPrice = param.personalizationPrice, gwpTitle = param.gwpTitle;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), showHeaderSubHeaderProductDetail = ref.staticFeatures.showHeaderSubHeaderProductDetail;
    var isOnlineOrPurchased = !isOffline || isPurchased;
    var showOutOfStockMessage = meta.outOfStock && meta.adjustQuantityMessage && !showAlertMessage;
    var showPromoExclusionMsgAboveProductDetails = (0,useFeature/* useFeature */.S)("SHOW_PROMO_EXCLUSION_MSG_ABOVE_PRODUCT_DETAILS");
    var showPromoExclusionMsgInBaseSize = (0,useFeature/* useFeature */.S)("SHOW_PROMO_EXCLUSION_MSG_IN_BASE_SIZE");
    var allowQuantityChange = allowUpdate && !isOffline;
    var header = item.__typename === "ProductCartItem" ? item.product.header : item.__typename === "GiftCardCartItem" ? meta.name : null;
    var subHeader = item.__typename === "ProductCartItem" && item.product.subHeader;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,twind.tw)("space-y-6 border p-3 xs:p-4", !compact && "md:p-5"),
        children: [
            item.__typename === "ProductCartItem" && item.restricted && /*#__PURE__*/ (0,jsx_runtime.jsx)(RestrictedProductMessage/* RestrictedProductMessage */.p, {
                plural: false,
                dataTestId: "restricted-cart-item-message"
            }),
            item.__typename === "ProductCartItem" && !item.restricted && item.bonusItemId && /*#__PURE__*/ (0,jsx_runtime.jsx)(GWP_FreeGiftMessage/* GWPFreeGiftMessage */.O, {
                gwpTitle: gwpTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center flex-grow",
                "data-test-id": "shopping-cart-item",
                "data-test-item-id": item.id,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sm:flex font-display w-full relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start flex-grow space-x-4 sm:space-x-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                href: preventItemLinks ? null : meta.pdpUrl,
                                className: (0,twind.tw)("relative flex-none flex flex-col", isPurchased && "opacity-100"),
                                "data-test-id": "cart-item-img-link",
                                disabled: isOffline,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,twind.tw)("w-24 2xs:w-28 xs:w-32 sm:w-36", !compact && "sm:w-48"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                                            src: meta.imageUrl.replace(/1000/g, "500"),
                                            alt: meta.name,
                                            width: 300
                                        })
                                    }),
                                    item.__typename === "ProductCartItem" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailabilityBadge/* AvailabilityBadge */.T, {
                                        className: "hidden 2xs:flex absolute bottom-1 left-1",
                                        outOfStock: meta.outOfStock,
                                        stockMessage: item === null || item === void 0 ? void 0 : item.stockMessage,
                                        stockStatus: AvailabilityBadge/* STOCK_MESSAGE_CODE */.v[(ref1 = item === null || item === void 0 ? void 0 : item.stockMessageCode) !== null && ref1 !== void 0 ? ref1 : "IN_STOCK"],
                                        offline: isOffline
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between w-full flex-col gap-4 md:flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                href: preventItemLinks ? null : meta.pdpUrl,
                                                className: (0,twind.tw)("relative flex-none flex flex-col", isPurchased && "opacity-100"),
                                                "data-test-id": "cart-product-title-link",
                                                disabled: isOffline,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: (0,twind.tw)("font-bold text-puma-black cursor-pointer leading-tight!", compact && "text-sm 2xs:text-base", !compact && "text-sm 2xs:text-base sm:text-xl lg:text-lg xl:text-xl"),
                                                            "data-test-id": "cart-product-title",
                                                            children: showHeaderSubHeaderProductDetail ? header : meta.name
                                                        }),
                                                        showHeaderSubHeaderProductDetail && subHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "w-full mobile:text-sm text-base text-puma-gray-60 line-clamp-2",
                                                            "data-test-id": "cart-product-subheader",
                                                            children: subHeader
                                                        })
                                                    ]
                                                })
                                            }),
                                            item.__typename === "ProductCartItem" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            promotionMessages.map(function(message) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    "data-test-id": "cart-item-promotion",
                                                                    className: (0,twind.tw)("text-puma-red text-xs xs:text-sm flex flex-wrap", !compact && "md:text-base lg:text-sm xl:text-base"),
                                                                    children: message
                                                                }, message);
                                                            }),
                                                            item.product.promotionExclusion && showPromoExclusionMsgAboveProductDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (0,twind.tw)("text-xs xs:text-sm flex flex-wrap uppercase", !compact && showPromoExclusionMsgInBaseSize ? "text-puma-red md:text-base lg:text-sm xl:text-base" : "text-puma-gray md:text-xs lg:text-xs xl:text-xs"),
                                                                children: t("promotionExclusionCart")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "color",
                                                                compact: compact,
                                                                name: t("color"),
                                                                info: item.product.colorName
                                                            }),
                                                            isOnlineOrPurchased && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "size",
                                                                compact: compact,
                                                                name: t("size"),
                                                                info: item.product.size.label
                                                            }),
                                                            item.customizationName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "name",
                                                                compact: compact,
                                                                name: t("name"),
                                                                info: item.customizationName
                                                            }),
                                                            item.customizationNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "number",
                                                                compact: compact,
                                                                name: t("number"),
                                                                info: item.customizationNumber
                                                            }),
                                                            item.customizationCost && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "customization",
                                                                compact: compact,
                                                                name: t("customization"),
                                                                info: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                                                    amount: parseInt(item.customizationCost)
                                                                })
                                                            }),
                                                            item.personalizationName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "name",
                                                                compact: compact,
                                                                name: t("name"),
                                                                info: item.personalizationName
                                                            }),
                                                            item.personalizationNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "number",
                                                                compact: compact,
                                                                name: t("number"),
                                                                info: item.personalizationNumber
                                                            }),
                                                            item.personalizationSurcharge && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "name",
                                                                compact: compact,
                                                                name: t("customizationCost"),
                                                                info: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                                                    amount: item.personalizationSurcharge
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                testId: "styleNumber",
                                                                compact: compact,
                                                                name: t("styleNumber"),
                                                                info: item.product.styleNumber
                                                            })
                                                        ]
                                                    }),
                                                    item.product.promotionExclusion && !showPromoExclusionMsgAboveProductDetails && showPromoExclusionMsgInBaseSize && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,twind.tw)("text-xs xs:text-sm flex flex-wrap", !compact && "md:text-base lg:text-sm xl:text-base"),
                                                        children: t("promotionExclusion")
                                                    }),
                                                    removing || !allowRemove ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        "data-test-id": "quantity",
                                                        className: (0,twind.tw)("flex items-center space-x-1 text-puma-black text-xs xs:text-sm", !compact && "md:text-base"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "capitalize text-puma-black-300",
                                                                children: [
                                                                    t("quantity"),
                                                                    ":",
                                                                    " "
                                                                ]
                                                            }),
                                                            item.quantity
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex w-24",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputSelect */.JDu, {
                                                            id: "quantity-select-".concat(item.id),
                                                            dataTestId: "quantity-select",
                                                            label: t("quantity"),
                                                            showLabel: false,
                                                            placeholder: t("qty"),
                                                            options: (0,countingNumbers/* countingNumbersAsDropdownList */._)(maxPurchasableQuantity, item.quantity),
                                                            value: item.quantity.toString(),
                                                            onChange: onChangeQuantity,
                                                            disabled: updating || !basketId || !allowQuantityChange
                                                        })
                                                    })
                                                ]
                                            }),
                                            showAlertMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "border border-puma-red rounded flex items-center p-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage/* AlertMessage */.g, {
                                                    dataTestId: "cart-item-alert-message",
                                                    icon: "exclamation-outline",
                                                    type: "warning",
                                                    children: error ? error : meta.adjustQuantityMessage
                                                })
                                            }),
                                            showOutOfStockMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage/* AlertMessage */.g, {
                                                icon: "exclamation-outline",
                                                type: "warning",
                                                children: meta.adjustQuantityMessage
                                            }),
                                            item.__typename === "GiftCardCartItem" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                        testId: "recipientEmail",
                                                        compact: compact,
                                                        name: t("recipientEmail"),
                                                        info: item.recipientEmail
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                        testId: "recipientName",
                                                        compact: compact,
                                                        name: t("recipientName"),
                                                        info: item.recipientName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                        testId: "senderName",
                                                        compact: compact,
                                                        name: t("senderName"),
                                                        info: item.senderName
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-start justify-between xs:items-end md:(flex-col justify-start space-x-3) xs:flex-row-reverse",
                                        children: [
                                            (isOnlineOrPurchased || item.__typename === "GiftCardCartItem") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "flex flex-col md:mb-5 text-left xs:text-right",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* ProductPrice */.jF, {
                                                    price: {
                                                        amount: totalProductPrice,
                                                        salePrice: salePrice,
                                                        promotionPrice: promotionPrice,
                                                        personalizationPrice: personalizationPrice
                                                    },
                                                    compact: !!compact
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row mt-4 md:mt-0",
                                                children: [
                                                    item.__typename === "ProductCartItem" && allowUpdate && !isOffline && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                        dataTestId: "edit-product-button",
                                                        variant: "ghost",
                                                        onClick: onEdit,
                                                        label: "Edit ".concat(meta.name),
                                                        icon: "pencil",
                                                        mode: "icon"
                                                    }),
                                                    allowRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                        "data-test-id": "remove-product-button",
                                                        disabled: removing || updating,
                                                        variant: "ghost",
                                                        onClick: onRemove,
                                                        label: "Remove ".concat(meta.name),
                                                        icon: "trash",
                                                        mode: "icon"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var primary = (ShoppingCartItemPrimaryNested);

// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./ui/components/ScheduledArrivalDate.tsx
var ScheduledArrivalDate = __webpack_require__(73022);
;// CONCATENATED MODULE: ./ui/components/ShoppingCartItem/secondary.tsx

















var ShoppingCartItemSecondaryNested = function(param) {
    var item = param.item, compact = param.compact, preventItemLinks = param.preventItemLinks, isOffline = param.isOffline, meta = param.meta, updating = param.updating, removing = param.removing, maxPurchasableQuantity = param.maxPurchasableQuantity, showAlertMessage = param.showAlertMessage, hideQuantity = param.hideQuantity, allowUpdate = param.allowUpdate, allowRemove = param.allowRemove, minicart = param.minicart, basketId = param.basketId, totalProductPrice = param.totalProductPrice, salePrice = param.salePrice, promotionMessages = param.promotionMessages, promotionPrice = param.promotionPrice, onChangeQuantity = param.onChangeQuantity, onEdit = param.onEdit, onRemove = param.onRemove, error = param.error, isFinalPrice = param.isFinalPrice, isPurchased = param.isPurchased, gwpTitle = param.gwpTitle;
    var ref, ref1, ref2;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var isOnlineOrPurchased = !isOffline || isPurchased;
    var router = (0,next_router.useRouter)();
    var isCheckoutPage = router.asPath.includes("checkout");
    var isTwoColumnsLayout = (0,useFeature/* useFeature */.S)("DISPLAY_PROMO_APPLIED_PROMOTION") && isCheckoutPage;
    var showOutOfStockMessage = meta.outOfStock && meta.adjustQuantityMessage && !showAlertMessage;
    var showPromoExclusionMsgAboveProductDetails = (0,useFeature/* useFeature */.S)("SHOW_PROMO_EXCLUSION_MSG_ABOVE_PRODUCT_DETAILS");
    var showPromoExclusionMsgInBaseSize = (0,useFeature/* useFeature */.S)("SHOW_PROMO_EXCLUSION_MSG_IN_BASE_SIZE");
    var isSalePriceElapsed = item.__typename === "ProductCartItem" ? (ref = item.product.productPrice) === null || ref === void 0 ? void 0 : ref.isSalePriceElapsed : undefined;
    var allowQuantityChange = allowUpdate && !isOffline;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,twind.tw)("space-y-6 border p-3 mobile:p-4", !compact && "md:p-5"),
        children: [
            item.__typename === "ProductCartItem" && item.restricted && /*#__PURE__*/ (0,jsx_runtime.jsx)(RestrictedProductMessage/* RestrictedProductMessage */.p, {
                plural: false,
                dataTestId: "restricted-cart-item-message"
            }),
            item.__typename === "ProductCartItem" && !item.restricted && item.bonusItemId && gwpTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(GWP_FreeGiftMessage/* GWPFreeGiftMessage */.O, {
                gwpTitle: gwpTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center flex-grow flex-col gap-y-4",
                "data-test-id": "shopping-cart-item",
                "data-test-item-id": item.id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sm:flex font-display w-full relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start flex-grow space-x-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                    href: preventItemLinks ? null : meta.pdpUrl,
                                    className: (0,twind.tw)("relative flex-none flex flex-col", isPurchased && "opacity-100"),
                                    "data-test-id": "cart-item-img-link",
                                    disabled: isOffline,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,twind.tw)("w-24 2xs:w-28 xs:w-36 sm:w-36", !compact && "sm:w-48"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                                                src: meta.imageUrl.replace(/1000/g, "500"),
                                                alt: meta.name,
                                                width: 300
                                            })
                                        }),
                                        item.__typename === "ProductCartItem" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailabilityBadge/* AvailabilityBadge */.T, {
                                            className: "hidden 2xs:flex absolute bottom-1 left-1",
                                            outOfStock: meta.outOfStock,
                                            stockMessage: item === null || item === void 0 ? void 0 : item.stockMessage,
                                            stockStatus: AvailabilityBadge/* STOCK_MESSAGE_CODE */.v[(ref3 = item === null || item === void 0 ? void 0 : item.stockMessageCode) !== null && ref3 !== void 0 ? ref3 : "IN_STOCK"],
                                            offline: isOffline
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between w-full flex-col gap-4 md:flex-row ".concat(minicart ? "flex-wrap" : "", " ").concat(compact ? "lg:flex-col xl:flex-row" : "", " ").concat(isTwoColumnsLayout ? "lg:flex-col xl:flex-col" : "", " "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "space-y-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: (0,twind.tw)("font-bold text-puma-black leading-tight!", compact && "text-sm 2xs:text-base", !compact && "text-sm 2xs:text-base sm:text-xl lg:text-lg xl:text-xl"),
                                                    "data-test-id": "cart-product-title",
                                                    children: meta.name
                                                }),
                                                item.__typename === "ProductCartItem" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "space-y-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                promotionMessages.map(function(message) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        "data-test-id": "cart-item-promotion",
                                                                        className: (0,twind.tw)("text-puma-red text-xs xs:text-sm flex flex-wrap break-all", !compact && "md:text-base lg:text-sm xl:text-base"),
                                                                        children: message
                                                                    }, message);
                                                                }),
                                                                item.product.promotionExclusion && showPromoExclusionMsgAboveProductDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (0,twind.tw)("text-xs xs:text-sm flex flex-wrap uppercase", !compact && showPromoExclusionMsgInBaseSize ? "text-puma-red md:text-base lg:text-sm xl:text-base" : "text-puma-gray md:text-xs lg:text-xs xl:text-xs"),
                                                                    children: t("promotionExclusionCart")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                    testId: "color",
                                                                    compact: compact,
                                                                    name: t("color"),
                                                                    info: item.product.colorName
                                                                }),
                                                                isOnlineOrPurchased && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                    testId: "size",
                                                                    compact: compact,
                                                                    name: t("size"),
                                                                    info: item.product.size.label
                                                                }),
                                                                item.customizationName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                    testId: "name",
                                                                    compact: compact,
                                                                    name: t("name"),
                                                                    info: item.customizationName
                                                                }),
                                                                item.customizationNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                    testId: "number",
                                                                    compact: compact,
                                                                    name: t("number"),
                                                                    info: item.customizationNumber
                                                                }),
                                                                item.customizationCost && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                    testId: "customization",
                                                                    compact: compact,
                                                                    name: t("customization"),
                                                                    info: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                                                        amount: parseInt(item.customizationCost)
                                                                    })
                                                                }),
                                                                item.personalizationName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                    testId: "name",
                                                                    compact: compact,
                                                                    name: t("name"),
                                                                    info: item.personalizationName
                                                                }),
                                                                item.personalizationNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                    testId: "number",
                                                                    compact: compact,
                                                                    name: t("number"),
                                                                    info: item.personalizationNumber
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                                    testId: "styleNumber",
                                                                    compact: compact,
                                                                    name: t("styleNumber"),
                                                                    info: item.product.styleNumber
                                                                }),
                                                                item.product.promotionExclusion && !showPromoExclusionMsgAboveProductDetails && showPromoExclusionMsgInBaseSize && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (0,twind.tw)("text-xs xs:text-sm flex flex-wrap", !compact && "md:text-base lg:text-sm xl:text-base"),
                                                                    children: t("promotionExclusion")
                                                                })
                                                            ]
                                                        }),
                                                        !hideQuantity && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: removing || !allowRemove ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                "data-test-id": "quantity",
                                                                className: (0,twind.tw)("flex items-center space-x-1 text-puma-black text-xs xs:text-sm", !compact && "md:text-base"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "capitalize text-puma-black-300",
                                                                        children: [
                                                                            t("quantity"),
                                                                            ":",
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    item.quantity
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex w-24",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputSelect */.JDu, {
                                                                    id: "quantity-select-".concat(item.id),
                                                                    dataTestId: "quantity-select",
                                                                    label: t("quantity"),
                                                                    showLabel: false,
                                                                    placeholder: t("qty"),
                                                                    options: (0,countingNumbers/* countingNumbersAsDropdownList */._)(maxPurchasableQuantity, item.quantity),
                                                                    value: item.quantity.toString(),
                                                                    onChange: onChangeQuantity,
                                                                    disabled: updating || !basketId || !allowQuantityChange
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                showAlertMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "border border-puma-red rounded flex items-center p-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage/* AlertMessage */.g, {
                                                        dataTestId: "cart-item-alert-message",
                                                        icon: "exclamation-outline",
                                                        type: "warning",
                                                        children: error ? error : meta.adjustQuantityMessage
                                                    })
                                                }),
                                                showOutOfStockMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage/* AlertMessage */.g, {
                                                    icon: "exclamation-outline",
                                                    type: "warning",
                                                    children: meta.adjustQuantityMessage
                                                }),
                                                item.__typename === "GiftCardCartItem" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                            testId: "recipientEmail",
                                                            compact: compact,
                                                            name: t("recipientEmail"),
                                                            info: item.recipientEmail
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                            testId: "recipientName",
                                                            compact: compact,
                                                            name: t("recipientName"),
                                                            info: item.recipientName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoRow, {
                                                            testId: "senderName",
                                                            compact: compact,
                                                            name: t("senderName"),
                                                            info: item.senderName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col items-start justify-between  md:(flex-col justify-start space-x-3) sm:flex-row-reverse sm:w-full xs:w-full ".concat(compact && !minicart ? "lg:items-start xl:items-end lg:space-x-0 xl:space-x-3" : "", " ").concat(minicart ? "w-full" : "sm:items-end", " ").concat(isTwoColumnsLayout ? "lg:w-auto lg:items-start xl:items-start" : ""),
                                            children: [
                                                (isOnlineOrPurchased || item.__typename === "GiftCardCartItem") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "flex flex-col md:mb-5 text-left ".concat(minicart ? "text-left" : "sm:text-right", " ").concat(compact && !minicart ? "lg:text-left xl:text-right" : "", " ").concat(isTwoColumnsLayout ? "lg:text-left xl:text-left" : ""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* ProductPrice */.jF, {
                                                        price: {
                                                            amount: totalProductPrice,
                                                            salePrice: salePrice,
                                                            promotionPrice: promotionPrice,
                                                            isSalePriceElapsed: isSalePriceElapsed
                                                        },
                                                        compact: !!compact,
                                                        isFinalPrice: isFinalPrice
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row space-x-3 mt-4 md:mt-0",
                                                    children: [
                                                        item.__typename === "ProductCartItem" && allowUpdate && !isOffline && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                            "data-test-id": "edit-product-button",
                                                            onClick: onEdit,
                                                            label: "Edit ".concat(meta.name),
                                                            variant: "ghost",
                                                            icon: "pencil",
                                                            mode: "icon"
                                                        }),
                                                        allowRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                            "data-test-id": "remove-product-button",
                                                            variant: "ghost",
                                                            disabled: removing || updating,
                                                            onClick: onRemove,
                                                            label: t("removeProduct", {
                                                                product: meta.name
                                                            }),
                                                            icon: "trash",
                                                            mode: "icon"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    item.__typename === "ProductCartItem" && ((ref1 = item.product.displayOutOfStock) === null || ref1 === void 0 ? void 0 : ref1.presale) && ((ref2 = item.product.displayOutOfStock) === null || ref2 === void 0 ? void 0 : ref2.validTo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduledArrivalDate/* default */.Z, {
                        preOrderDeliveryDate: item.product.displayOutOfStock.validTo
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var secondary = (ShoppingCartItemSecondaryNested);

;// CONCATENATED MODULE: ./ui/components/ShoppingCartItem/index.tsx


























var ProductInfoRow = function(param) {
    var name = param.name, info = param.info, compact = param.compact, testId = param.testId, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (0,twind.tw)("text-xs xs:text-sm flex flex-wrap break-all", !compact && "md:text-base lg:text-sm xl:text-base", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "capitalize text-puma-black-300",
                children: [
                    name,
                    ":\xa0"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "data-test-id": testId,
                children: info
            })
        ]
    });
};
var ShoppingCartItem = function(param) {
    var compact = param.compact, item = param.item, basketId = param.basketId, allowRemove = param.allowRemove, allowUpdate = param.allowUpdate, minicart = param.minicart, preventItemLinks = param.preventItemLinks, errorHandling = param.errorHandling, updating = param.updating, setUpdating = param.setUpdating, isPurchased = param.isPurchased, hideQuantity = param.hideQuantity, isFinalPrice = param.isFinalPrice, _gwpTitle = param.gwpTitle, gwpTitle = _gwpTitle === void 0 ? "" : _gwpTitle;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var personalizationEnabled = (0,useFeature/* useFeature */.S)("PERSONALIZATION_ENABLED");
    var shoppingCartItemType = (0,useSiteConfig/* useSiteConfig */.N)().shoppingCartItemType;
    var ref10 = (0,useResizeObserver/* useResizeObserver */.y)().ref;
    var ref11 = (0,useCart/* useCart */.j)(), removeFromCart = ref11.removeFromCart, updateInCart = ref11.updateInCart;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRemoveGiftCardFromCartMutation */.Joh)(), 2), removeGiftCard = ref12[1];
    var getMetaForProduct = (0,useCartProductMeta/* useCartProductMeta */.L)().getMetaForProduct;
    var ref13 = (0,react.useState)(false), loading = ref13[0], setLoading = ref13[1];
    var ref14 = (0,react.useState)(false), editing = ref14[0], setEditing = ref14[1];
    var ref15 = (0,react.useState)(false), removing = ref15[0], setRemoving = ref15[1];
    var ref16 = (0,react.useState)(), error = ref16[0], setError = ref16[1];
    var meta = getMetaForProduct(item, t("digitalGiftCard"), compact);
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var ShoppingItemContent = (0,react.useMemo)(function() {
        if (shoppingCartItemType === types/* ComponentType.SECONDARY */.r.SECONDARY) {
            return secondary;
        }
        return primary;
    }, [
        shoppingCartItemType
    ]);
    var isOffline = item.__typename === "ProductCartItem" ? item.product.offline : false;
    var maxOrderableQuantity = item.__typename === "ProductCartItem" ? item.product.maxOrderableQuantity : 0;
    var inventoryQuantity = item.__typename === "ProductCartItem" ? item.product.inventory : 0;
    var itemQuantity = item.__typename === "ProductCartItem" ? item.quantity : 0;
    var maxQuantity = (0,products/* getMaxQuantity */.NN)({
        maxOrderableQuantity: maxOrderableQuantity,
        inventoryQuantity: inventoryQuantity
    });
    var totalInCartPrice = item.__typename === "ProductCartItem" ? item.inCartPrice * itemQuantity : undefined;
    var totalProductPrice = item.__typename === "ProductCartItem" && ((ref = item.product.productPrice) === null || ref === void 0 ? void 0 : ref.price) ? ((ref1 = item.product.productPrice) === null || ref1 === void 0 ? void 0 : ref1.price) * itemQuantity : item.amount;
    var salePrice = item.__typename === "ProductCartItem" && ((ref2 = item.product.productPrice) === null || ref2 === void 0 ? void 0 : ref2.salePrice) ? ((ref3 = item.product.productPrice) === null || ref3 === void 0 ? void 0 : ref3.salePrice) * itemQuantity : undefined;
    var promotionPrice = item.__typename === "ProductCartItem" && ((ref4 = item.product.productPrice) === null || ref4 === void 0 ? void 0 : ref4.promotionPrice) ? ((ref5 = item.product.productPrice) === null || ref5 === void 0 ? void 0 : ref5.promotionPrice) * itemQuantity : totalInCartPrice;
    var purchasedPrice = item.__typename === "ProductCartItem" && ((ref6 = item.purchasedPrice) === null || ref6 === void 0 ? void 0 : ref6.price) ? ((ref7 = item.purchasedPrice) === null || ref7 === void 0 ? void 0 : ref7.price) * itemQuantity : item.amount;
    var purchasedPromotionPrice = item.__typename === "ProductCartItem" && ((ref8 = item.purchasedPrice) === null || ref8 === void 0 ? void 0 : ref8.promotionPrice) ? ((ref9 = item.purchasedPrice) === null || ref9 === void 0 ? void 0 : ref9.promotionPrice) * itemQuantity : undefined;
    var personalizationTotalPrice = item.__typename === "ProductCartItem" && (0,isNotNullish/* isNotNullish */.l)(item.personalizationPrice) ? parseFloat(item.personalizationPrice) * itemQuantity : undefined;
    var onQuantityChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newQty) {
            var ref, ref1, errors, oldQuantity, newQuantity, quantityDiff, newValue, res, _tmp, ref2, ref3, ga4Item, analyticsItem, _tmp1, analyticsImage, ecommerceData, _tmp2, _tmp3, _tmp4, _tmp5, error, ref4;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!basketId || !setUpdating || item.__typename !== "ProductCartItem") {
                            return [
                                2
                            ];
                        }
                        if (errorHandling === null || errorHandling === void 0 ? void 0 : errorHandling.updateError) {
                            setError(undefined);
                            ;
                            errors = ((ref1 = errorHandling === null || errorHandling === void 0 ? void 0 : errorHandling.cartUpdateError) !== null && ref1 !== void 0 ? ref1 : []).filter(function(error) {
                                return error !== item.product.id;
                            });
                            errorHandling === null || errorHandling === void 0 ? void 0 : errorHandling.updateError(errors);
                        }
                        setUpdating(true);
                        oldQuantity = item.quantity;
                        newQuantity = Number.parseInt(newQty);
                        quantityDiff = newQuantity - oldQuantity;
                        newValue = Math.round(item.inCartPrice * (quantityDiff > 0 ? quantityDiff : oldQuantity - newQuantity) * 100) / 100;
                        _tmp = {};
                        return [
                            4,
                            updateInCart((_tmp.itemId = item.id, _tmp.quantity = newQuantity, _tmp.productId = item.product.id, _tmp.masterId = item.product.masterId, _tmp))
                        ];
                    case 1:
                        res = _state.sent();
                        _tmp1 = {};
                        _tmp2 = {};
                        _tmp3 = {};
                        _tmp4 = {};
                        _tmp5 = {};
                        if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.updateItemInCart) {
                            ;
                            ga4Item = (0,ga4Items/* getGa4Item */.Vr)((ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.styleNumber);
                            analyticsItem = (0,analytics/* transformListProductToAnalyticsItem */.pD)((_tmp1.product = item.product, _tmp1.currency = currency.code, _tmp1.quantity = quantityDiff > 0 ? quantityDiff : oldQuantity - newQuantity, _tmp1.categories = {
                                item_category: item.product.primaryCategoryId
                            }, _tmp1.itemListId = ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid, _tmp1.itemListName = ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname, _tmp1.index = ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.idx, _tmp1.creativeName = ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cname, _tmp1.creativeSlot = ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cslot, _tmp1.promotionId = ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pid, _tmp1.promotionName = ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pname, _tmp1.size = (ref3 = item.product) === null || ref3 === void 0 ? void 0 : ref3.size.label, _tmp1));
                            analyticsImage = (0,analytics/* getAnalyticsImage */.Ub)(meta.imageUrl, item.product.images[0].href);
                            ecommerceData = (_tmp2.ecommerce = {
                                item_list_id: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
                                item_list_name: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
                                currency: currency.code,
                                value: newValue,
                                image_type: analyticsImage.imageType,
                                image_number: analyticsImage.imageNumber !== "unavailable" ? (0,analytics/* addPrefixToAnalyticProp */.lL)(analyticsImage.imageNumber) : undefined,
                                items: [
                                    analyticsItem
                                ]
                            }, _tmp2);
                            if (quantityDiff > 0) {
                                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4EC_AddItemToCart */._q.GA4EC_AddItemToCart, (0,_object_spread/* default */.Z)((_tmp3.event_name = analytics/* AnalyticsEvents.ADD_ITEM_LIST_TO_CART */._q.ADD_ITEM_LIST_TO_CART, _tmp3), ecommerceData));
                            } else {
                                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4EC_RemoveItemFromCart */._q.GA4EC_RemoveItemFromCart, (0,_object_spread/* default */.Z)((_tmp4.event_name = analytics/* AnalyticsEvents.REMOVE_ITEM_FROM_CART */._q.REMOVE_ITEM_FROM_CART, _tmp4), ecommerceData));
                            }
                            if (pageviewEventHasFired) {
                                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, (_tmp5.event_name = analytics/* AnalyticsEvents.QUANTITY_CHANGE */._q.QUANTITY_CHANGE, _tmp5.event_params = {
                                    item_id_ep: analyticsItem.item_id,
                                    item_name_ep: analyticsItem.item_name
                                }, _tmp5));
                            }
                        }
                        error = (0,extractError/* extractError */.d)(res);
                        if (error) {
                            if ((errorHandling === null || errorHandling === void 0 ? void 0 : errorHandling.updateError) && (errorHandling === null || errorHandling === void 0 ? void 0 : errorHandling.cartUpdateError)) {
                                ;
                                errorHandling.updateError((ref4 = errorHandling.cartUpdateError) === null || ref4 === void 0 ? void 0 : ref4.concat(item.product.id));
                                setError(error);
                            }
                        }
                        setUpdating(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(newQty) {
            return _ref.apply(this, arguments);
        };
    }(), [
        basketId,
        item,
        updateInCart,
        setUpdating,
        errorHandling,
        currency.code,
        meta.imageUrl,
        pageviewEventHasFired, 
    ]);
    var handleClickEdit = function() {
        return setEditing(true);
    };
    var handleClickRemove = function() {
        return setRemoving(true);
    };
    var showAlertMessage = Boolean(meta.adjustQuantityMessage || error);
    var promotionMessages = item.__typename === "ProductCartItem" && item.hasStock ? item.adjustments.map(function(adjustment) {
        var ref;
        return (ref = adjustment.promotion) === null || ref === void 0 ? void 0 : ref.calloutMessage;
    }).filter(function(item) {
        return Boolean(item);
    }) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                ref: ref10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingItemContent, {
                    item: item,
                    compact: compact,
                    preventItemLinks: preventItemLinks,
                    isOffline: isOffline,
                    meta: meta,
                    updating: updating,
                    removing: removing,
                    maxPurchasableQuantity: maxQuantity,
                    showAlertMessage: showAlertMessage,
                    allowUpdate: !!allowUpdate,
                    allowRemove: !!allowRemove,
                    minicart: !!minicart,
                    hideQuantity: !!hideQuantity,
                    onChangeQuantity: onQuantityChange,
                    basketId: basketId,
                    totalProductPrice: isPurchased ? purchasedPrice : totalProductPrice,
                    salePrice: isPurchased ? undefined : salePrice,
                    promotionMessages: promotionMessages,
                    promotionPrice: isPurchased ? purchasedPromotionPrice : promotionPrice,
                    gwpTitle: gwpTitle,
                    personalizationPrice: personalizationTotalPrice,
                    onEdit: handleClickEdit,
                    onRemove: handleClickRemove,
                    error: error,
                    isPurchased: isPurchased,
                    isFinalPrice: isFinalPrice
                })
            }),
            item.__typename === "ProductCartItem" && allowUpdate && editing && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditProductModal/* EditProductModal */.V, {
                price: item.inCartPrice,
                size: item.product.size.value,
                color: item.product.colorValue,
                id: item.product.id,
                masterId: item.product.masterId,
                onClose: function() {
                    return setEditing(false);
                },
                update: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                        var size, swatch, ref, productPersonalization, _tmp, updateRes, _tmp1, oldKey, ga4Item, updatedGa4Item, _tmp2, _tmp3;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    size = param.size, swatch = param.swatch;
                                    _tmp = {};
                                    productPersonalization = personalizationEnabled ? (_tmp.imageURL = item.personalizationImageURL, _tmp.largeImageURL = item.personalizationLargeImageURL, _tmp.nameText = item.personalizationName, _tmp.numberText = item.personalizationNumber, _tmp.price = item.personalizationPrice, _tmp.recipeID = item.personalizationRecipeID, _tmp) : null;
                                    _tmp1 = {};
                                    return [
                                        4,
                                        updateInCart((_tmp1.itemId = item.id, _tmp1.productId = item.product.masterId, _tmp1.quantity = item.quantity, _tmp1.swatch = swatch, _tmp1.size = size, _tmp1.productPersonalization = (0,_object_spread/* default */.Z)({}, productPersonalization), _tmp1.masterId = item.product.masterId, _tmp1))
                                    ];
                                case 1:
                                    updateRes = _state.sent();
                                    _tmp2 = {};
                                    _tmp3 = {};
                                    if ((ref = updateRes.data) === null || ref === void 0 ? void 0 : ref.updateItemInCart) {
                                        oldKey = "".concat(item.product.masterId, "_").concat(item.product.colorValue);
                                        ga4Item = (0,ga4Items/* getGa4Item */.Vr)(oldKey);
                                        if (ga4Item) {
                                            updatedGa4Item = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, ga4Item), (_tmp3.cart = "1", _tmp3));
                                            (0,ga4Items/* removeGa4ItemFromMap */.EI)(oldKey);
                                            (0,ga4Items/* setGa4ItemInMap */.HH)("".concat(item.product.masterId, "_").concat(swatch), updatedGa4Item);
                                        }
                                    }
                                    return [
                                        2,
                                        updateRes
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            removing && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmModal/* ConfirmModal */.s, {
                loading: loading,
                onClickOutside: function() {
                    return setRemoving(false);
                },
                onConfirm: function() {
                    if (basketId) {
                        setLoading(true);
                        if (item.__typename === "ProductCartItem") {
                            removeFromCart({
                                itemId: item.id
                            }).then(function() {
                                var ref;
                                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.REMOVE_FROM_CART */._q.REMOVE_FROM_CART, {
                                    ecommerce: {
                                        currencyCode: currency.code,
                                        remove: {
                                            products: [
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,analytics/* transformVariantProductToAnalyticsProduct */.Tp)(item.product, true)), {
                                                    quantity: item.quantity
                                                }), 
                                            ]
                                        }
                                    }
                                });
                                var ga4Item = (0,ga4Items/* getGa4Item */.Vr)((ref = item.product) === null || ref === void 0 ? void 0 : ref.styleNumber);
                                if (ga4Item) {
                                    var ref1;
                                    var modifiedGa4Item = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ga4Item), {
                                        cart: undefined
                                    });
                                    (0,ga4Items/* setGa4ItemInMap */.HH)((ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.styleNumber, modifiedGa4Item, true);
                                }
                                var analyticsItem = (0,analytics/* transformListProductToAnalyticsItem */.pD)({
                                    product: item.product,
                                    currency: currency.code,
                                    quantity: item.quantity,
                                    categories: {
                                        item_category: item.product.primaryCategoryId
                                    },
                                    itemListId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
                                    itemListName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
                                    index: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.idx,
                                    creativeName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cname,
                                    creativeSlot: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cslot,
                                    promotionId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pid,
                                    promotionName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pname,
                                    size: item.product.size.label
                                });
                                var analyticsImage = (0,analytics/* getAnalyticsImage */.Ub)(meta.imageUrl, item.product.images[0].href);
                                var newValue = item.inCartPrice * item.quantity;
                                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4EC_RemoveItemFromCart */._q.GA4EC_RemoveItemFromCart, {
                                    event_name: analytics/* AnalyticsEvents.REMOVE_ITEM_FROM_CART */._q.REMOVE_ITEM_FROM_CART,
                                    ecommerce: {
                                        item_list_id: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
                                        item_list_name: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
                                        currency: currency.code,
                                        value: newValue,
                                        image_type: analyticsImage.imageType,
                                        image_number: analyticsImage.imageNumber !== "unavailable" ? (0,analytics/* addPrefixToAnalyticProp */.lL)(analyticsImage.imageNumber) : undefined,
                                        items: [
                                            analyticsItem
                                        ]
                                    }
                                });
                                setRemoving(false);
                                setLoading(false);
                            });
                        } else {
                            removeGiftCard({
                                input: {
                                    basketId: basketId,
                                    giftCardId: item.id
                                }
                            }).then(function() {
                                setRemoving(false);
                                setLoading(false);
                            });
                        }
                    }
                },
                dataTestId: "cart-remove-item-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-xl pr-8",
                        children: t("removeItemConfirmation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartItem, {
                        item: item,
                        gwpTitle: gwpTitle,
                        compact: true,
                        minicart: true,
                        hideQuantity: true
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);